export default state => ({
  ...state,
  saveProductDesignAlert: false,
});
